import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// tslint:disable-next-line:import-spacing
import  jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { AuthorizedUser } from '../../../core/services/authorized-user.service';

@Component({
selector: 'app-bonaza-details',
templateUrl: './bonaza-details.component.html',
styleUrls: ['./bonaza-details.component.scss']
})
export class BonazaDetailsComponent implements OnInit {
@Output() closeBonanza = new EventEmitter();
@Output() closeMobileBonanza = new EventEmitter();
name: string;
@Input() totalCustomer: number;
@Input() totalAmountMoved: number;
@Input() mobile: string;
constructor(public user: AuthorizedUser) { }

ngOnInit(): void {
this.initialize();
}

initialize(){
this.name = this.user.name;
}

setClose() {
if (this.mobile){
this.closeMobileBonanza.emit(true);
}
else{
this.closeBonanza.emit(true);
}
}

generatePDF(isMobile?) {
const data = document.getElementById('contentToConvert');
if (!isMobile) {
document.getElementById('bonanza-icon').style.display = 'none';
document.getElementById('controlButtons').style.display = 'none';
}
else {
document.getElementById('controlButtonsMobile').style.display = 'none';
}
html2canvas(data).then(canvas => {
const imgWidth = 210;
const imgHeight = 300;
const contentDataURL = canvas.toDataURL('image/png');
const pdf = new jsPDF('p', 'mm', 'a4');
const position = 0;
pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
pdf.save('newPDF.pdf');
if (!isMobile) {
document.getElementById('bonanza-icon').style.display = 'block';
document.getElementById('controlButtons').style.display = 'block';
}
else {
document.getElementById('controlButtonsMobile').style.display = 'block';
}
});
}

}
